import React, {ReactElement, ReactNode} from "react";
import {Tooltip, Typography} from "@material-ui/core";
import useStyles from "./styles";

const TooltipIcon = ({title, icon}: {title: ReactNode; icon: ReactElement}) => {
  const classes = useStyles();

  return (
    <Tooltip
      classes={{tooltip: classes.tooltip}}
      placement="top-start"
      title={<Typography className={classes.tooltipText}>{title}</Typography>}
    >
      <span>{icon}</span>
    </Tooltip>
  );
};

export default TooltipIcon;
